import { Link } from 'react-router-dom';
import { getPopularArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function PopularContent() {
  const popular = getPopularArticles(6);

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || slug;
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
              热门音频推荐
            </h2>
            <p className="text-base text-foreground-600">
              大家都在听的精选内容，发现你的下一个最爱
            </p>
          </div>
          <Link
            to="/category/whisper"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {popular.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-lg bg-background-100/70 border border-background-200/60 hover:border-primary-200/50 transition-all overflow-hidden"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-2.5 py-0.5 rounded-full text-xs bg-accent-100 text-accent-700">
                    {getCategoryName(article.category)}
                  </span>
                  <span className="text-xs text-foreground-500">{article.duration}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-headphone-line"></i>
                    {article.listenCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}